$(function () {
  var phoneVal = '';
  var industryVal = '';
  // 提交验证
  $('[js_free_trial_box]').on('click', '[js_free_trial_btn]', function () {
    var box = $(this).parents('[js_free_trial_box]');
    var err = box.find('[js_free_trial_error]');
    phoneVal = box.find('.free_tril_tel').val();
    industryVal = box.find('.free_tril_industry').val();
    if (!phoneValidate(phoneVal)) {
      delayExecuteWrapper(function () {
        err.css('opacity', '1').find('span').html('请输入正确的手机号!');
      }, function () {
        err.css('opacity', '0');
      })
      return;
    } else {
      err.css('opacity', '0');
    }
    initGeetest(verifyHandler);
  })
  function verifyHandler(bizResult, temp) {
    if (bizResult === true) {
      freeTrialFunc(temp);
    }
  };
  // 留资提交
  function freeTrialFunc(temp) {
    var pid = new URLSearchParams(location.search).get('pid') ? new URLSearchParams(location.search).get('pid') : (JSCookie.get('pidtt') ? JSCookie.get('pidtt') : '');
    var url = encodeURI(window.location.href);
    var data = {
      cellphone: phoneVal,
      web_code: 'cmf',
      pid: pid,
      uid:P_AccountId,
      channel_url: url,
    };
    Object.assign(data, temp);
    $.ajax({
      url: 'https://api.pop-fashion.com/app/stayconsultation/',
      type: 'GET',
      dataType: 'jsonp',
      data: data,
      success: function (data) {
        if (data.code == '0') {
          $('[js_free_trial_success]').show();
          $('[js_free_trial_box]').hide();
          $('[js_free_trial_box]').find('.free_tril_tel').val('')
        } else {

        }
        is_geetest = false;
      },
      error: function () {
        is_geetest = false;
      }
    })
  }

  $("[js_free_trial_box]").on("click",".close_btn", function() {
    $('[js_free_trial_box]').hide();
    $('[js_free_trial_box]').find('.free_tril_tel').val('')
    if(is_home == "home") {
      setTimeout(function() {
        $(".embed-icon-default").trigger('click');
      },5000)
    }
  });

  // 手机号校验
  function phoneValidate(val) {
    if (val.length === 11 && val.replace(/[\d]/g, '') === '') {
      return true;
    }
    return false;
  }

  // 延迟盒子
  function delayExecuteWrapper(fn1, fn2, time) {
    fn1 && fn1();
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      fn2 && fn2();
    }, time || 3000);
  }

  // 显示留资
  $("body").on("click", ".js_sem_show", function() {
    $('[js_free_trial_box]').show();
    $(".js_authority_view_layer").hide();
  })
});
